module.exports = __webpack_public_path__ + "img/vip_big.91e84dcf.svg";